import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showDialog) = $event)),
    width: "700",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.dialogTitle), 1),
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1,
                    __: [6]
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (_ctx.submitError)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "error",
                    density: "compact",
                    class: "mb-3",
                    closable: "",
                    "onClick:close": _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitError = ''))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.submitError), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_form, {
                ref: "formRef",
                modelValue: _ctx.formValid,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formValid) = $event)),
                onSubmit: _withModifiers(_ctx.submit, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.serverName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.serverName) = $event)),
                    label: "Title / Server Name",
                    rules: _ctx.serverNameRules,
                    counter: 120,
                    required: "",
                    readonly: _ctx.mode === 'external_removal',
                    variant: "outlined",
                    density: "compact",
                    class: "mb-2"
                  }, null, 8, ["modelValue", "rules", "readonly"]),
                  _createVNode(_component_v_textarea, {
                    modelValue: _ctx.reason,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reason) = $event)),
                    label: "Reason",
                    rules: _ctx.reasonRules,
                    counter: 500,
                    required: "",
                    variant: "outlined",
                    density: "compact",
                    rows: "3",
                    class: "mb-2"
                  }, null, 8, ["modelValue", "rules"]),
                  _createElementVNode("div", _hoisted_1, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-subtitle-2 mb-1" }, "Links", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "d-flex align-center mb-1"
                      }, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.links[index],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.links[index]) = $event),
                          label: `Link ${index + 1}`,
                          rules: _ctx.linkRules,
                          variant: "outlined",
                          density: "compact",
                          "hide-details": "auto",
                          class: "flex-grow-1"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "rules"]),
                        _createVNode(_component_v_btn, {
                          icon: "",
                          variant: "text",
                          size: "small",
                          onClick: ($event: any) => (_ctx.removeLink(index)),
                          class: "ml-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode("mdi-close")
                              ])),
                              _: 1,
                              __: [7]
                            })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    }), 128)),
                    (_ctx.links.length < 10)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          variant: "text",
                          size: "small",
                          color: "primary",
                          "prepend-icon": "mdi-plus",
                          onClick: _ctx.addLink
                        }, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createTextVNode(" Add Link ")
                          ])),
                          _: 1,
                          __: [8]
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_v_textarea, {
                    modelValue: _ctx.notes,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.notes) = $event)),
                    label: "Notes",
                    rules: _ctx.notesRules,
                    counter: 1000,
                    variant: "outlined",
                    density: "compact",
                    rows: "2",
                    class: "mb-2"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }, 8, ["modelValue", "onSubmit"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "px-4 pb-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("Cancel")
                ])),
                _: 1,
                __: [10]
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "flat",
                disabled: !_ctx.formValid || _ctx.submitting,
                loading: _ctx.submitting,
                onClick: _ctx.submit
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode(" Submit Request ")
                ])),
                _: 1,
                __: [11]
              }, 8, ["disabled", "loading", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}